import React, { memo, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import classNames from 'classnames';
import QRCode from 'qrcode.react';

import { CONTEXT, STORE_3G_HOST, STORE_3G_CHANNEL } from '../../config';
import AButton from '../../components/AButton/AButton';
import Rate from '../../components/Rate/Rate';
import { logging } from '../../actions/log';
import styles from './SoftDetailSimple.module.less';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ softDetails, match }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  useEffect(() => {}, [dispatch]);

  // 点击查看二维码
  const handleShowCloseQRcode = useCallback(
    ev => {
      dispatch(
        logging({
          category: 'C',
          action: 'AppDetail_QRCode',
          label: '',
          param2: {
            source: 'AppDetail',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: match.params.pn,
            packageName: match.params.pn,
            versionCode: match.params.vc,
            softType: '1',
          },
          param3: match.params.bizInfo,
        }),
      );
    },
    [dispatch, logInfoData, match],
  );

  return (
    <div className={styles.detail_simple}>
      <div className="detail_logo">
        <img className="detail_img" src={softDetails.logoFile} />
        <div className={'detail_android_logo'} />
      </div>
      <div className="detail_info">
        <div className="detail_info_line">
          <div className="detail_info_title">{softDetails.softName}</div>
          {softDetails.score > 70 && (
            <div className="detail_info_score">
              <Rate score={(softDetails.score / 20).toFixed(0)} />
            </div>
          )}
        </div>
      </div>
      <div className="detail_opt">
        <div className="detail_qrcode_mini" onMouseOver={e => handleShowCloseQRcode(e)}>
          <div className="detail_qrcode">
            <div className="detail_qrcode_text">可使用安卓手机扫描下载</div>
            <QRCode
              className="qrcode_image"
              size={105}
              level="Q"
              value={`${STORE_3G_HOST}/redsea/${softDetails.packageName}?ch=${STORE_3G_CHANNEL}`}
            />
          </div>
        </div>
        <AButton
          soft={{ ...softDetails, bizInfo: softDetails.bizInfo }}
          info={{
            className: styles.soft_btn,
            className_busing: styles.soft_btn_busing,
            className_open: styles.soft_button_open,
            text: '立即安装',
            isCompetitive: true,
          }}
          logInfo={{
            source: 'AppDetail',
            isSearch:
              logInfoData.source_p &&
              (logInfoData.source_p.indexOf('Search') > -1 ||
                logInfoData.source_p.indexOf('Search_Try') > -1 ||
                logInfoData.source_p.indexOf('Search_Lenovo') > -1),
          }}
        />
      </div>
    </div>
  );
});
